export default __webpack_public_path__ + "static/media/mariaFilo_mob_banner_3.0d8a155a.jpg";